module.exports = "<svg style=\"width: 16px; height: 16px\" viewBox=\"0 0 24 24\"><path d=\"M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/download.svg
// module id = 1293
// module chunks = 0